import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ObjectStructures/constants";

export const clearObjectStructures = createAction(`${moduleSlug}/CLEAR_OBJECT_STRUCTURES`);

export const getObjectStructuresEntities = createAction(`${moduleSlug}/GET_ENTITIES`);
export const getObjectStructuresSuccess = createAction(`${moduleSlug}/GET_ENTITIES/SUCCESS`);
export const getObjectStructuresError = createAction(`${moduleSlug}/GET_ENTITIES/ERROR`);

export const setObjectStructuresDialog = createAction(`${moduleSlug}/SET_OBJECT_STRUCTURES_DIALOG`);
export const mergeObjectStructuresDialog = createAction(`${moduleSlug}/MERGE_OBJECT_STRUCTURES_DIALOG`);
export const storeObjectStructures = createAction(`${moduleSlug}/STORE_OBJECT_STRUCTURES`);

export const setValidatorsObjectStructureDialog = createAction(`${moduleSlug}/SET_VALIDATORS_OBJECT_STRUCTURES_DIALOG`);
export const mergeValidatorsObjectStructureDialog = createAction(`${moduleSlug}/MERGE_VALIDATORS_OBJECT_STRUCTURES_DIALOG`);
